import { Quote } from '@features/invoices/types/quotes/quote'

export const getQuoteQueryData = (quoteId: string, quotes: Quote[]): Quote | undefined => {
  const quote = quotes.find(({ id }) => id.toString() === quoteId)

  return quote
}
